import { relations } from 'drizzle-orm';
import { index, integer, pgTable, primaryKey, varchar } from 'drizzle-orm/pg-core';
import { Provider } from './account';
import { application } from './application';

export type RateLimitScope = 'global' | 'endpoint' | 'endpoints';
export type RateLimitWindowUnit = 'second' | 'minute' | 'hour' | 'day';

export const rateLimiter = pgTable(
  'rate_limiter',
  {
    id: integer('id').primaryKey(),
    provider: varchar({ length: 255 }).notNull().$type<Provider>(),
    scope: varchar({ length: 20 }).notNull().$type<RateLimitScope>(),
    endpoint_path: varchar({ length: 255 }), // null if global
    endpoint_method: varchar({ length: 10 }), // null if global
    min_limit: integer().notNull(),
    max_limit: integer().notNull(),
    default_limit: integer().notNull(),
    window_duration: integer().notNull(),
    window_unit: varchar({ length: 10 }).notNull().$type<RateLimitWindowUnit>(),
  },
  (t) => [
    index('rate_limiter_provider_scope_idx').on(t.provider, t.scope),
    index('rate_limiter_provider_scope_method_path_idx').on(t.provider, t.scope, t.endpoint_method, t.endpoint_path),
  ],
);

export const rateLimiterRelations = relations(rateLimiter, ({ many }) => ({
  settings: many(rateLimitSetting),
}));

export const rateLimitSetting = pgTable(
  'rate_limit_setting',
  {
    application_id: integer()
      .notNull()
      .references(() => application.id, { onDelete: 'cascade' }),
    rate_limiter_id: integer()
      .notNull()
      .references(() => rateLimiter.id, { onDelete: 'cascade' }),
    limit: integer().notNull(),
  },
  (table) => [
    // Ensure unique combination of application and rate limiter
    primaryKey({ columns: [table.application_id, table.rate_limiter_id] }),
  ],
);

export const rateLimitSettingRelations = relations(rateLimitSetting, ({ one }) => ({
  rate_limiter: one(rateLimiter, {
    fields: [rateLimitSetting.rate_limiter_id],
    references: [rateLimiter.id],
  }),
  application: one(application, {
    fields: [rateLimitSetting.application_id],
    references: [application.id],
  }),
}));
